import * as React from 'react'
import { observer } from 'mobx-react'
import { IBaseProduct, productName } from '@getgreenline/homi-shared'
import { LoadingAnimation } from '../../../../../../components/LoadingAnimation'
import { AuditDescription } from './AuditDescription'
import { IProductWithBatchTrackStatus } from '../'
import { AuditBulkImport } from './AuditBulkImport'
import './Side.scss'
import { BlazeButton } from '../../../../../../components/CustomButtons/BlazeButton'
import { AuditStore } from '../EditAuditStore'
import { message } from 'antd'
import { AsyncProductInput } from '../../../../../../components/GrInput/AsyncProductInput'
import { AuditModels, AuditProductModels } from '@getgreenline/audits'
import { parseErrorMsg } from '../../../../../../utilities/helpers'

interface Props {
  audit: AuditModels.CreateInventoryAudit
  auditStore: AuditStore
  createAuditProducts: (
    products: IProductWithBatchTrackStatus[],
  ) => Promise<AuditProductModels.EditAuditProduct[]>
  isBarcodeListening: boolean
  toggleBarcodeListener: VoidFunction
  focusOnAuditProductRecord: (matchingProductRecord: AuditProductModels.EditAuditProduct) => void
}

@observer
export class Side extends React.Component<Props, {}> {
  handleOnSelect = async (products: IBaseProduct[]): Promise<void> => {
    for (const product of products) {
      const productToAdd = {
        sku: product.sku,
        barcode: product.barcode,
        productId: product.id,
        productName: productName(product),
        productUnit: product.unit,
        isBatchTracked: product.isBatchTracked,
        purchasePrice: product.purchasePrice,
      }

      try {
        const createdProduct = (await this.props.createAuditProducts([productToAdd]))[0]

        message.success(`${productName(product)} added`)

        this.props.focusOnAuditProductRecord(createdProduct)
      } catch (error) {
        message.error(
          parseErrorMsg(error) ||
            `There was an error while adding ${productToAdd.productName} to this audit`,
        )
      }
    }
  }
  render() {
    const { audit, auditStore, isBarcodeListening, toggleBarcodeListener } = this.props

    if (!audit.id) {
      return <LoadingAnimation />
    }

    return (
      <div className='side__inner-wrapper'>
        <div className='white-rounded-container'>
          <AuditDescription audit={audit} auditStore={auditStore} />
        </div>

        {auditStore.isEditable && (
          <div className='pb-0 white-rounded-container d-flex flex-wrap'>
            <div className='mr-2 mb-2' style={{ maxWidth: 290, width: '100%' }}>
              <AsyncProductInput
                showSearch
                mode='default'
                placeholder='Add a product'
                className='w-100'
                allowClear
                productIdsToHide={audit.products.map((line) => line.productId || '')}
                onChange={(products) => this.handleOnSelect(products)}
              />
            </div>

            <AuditBulkImport className='mr-2 mb-2' audit={audit} auditStore={auditStore} />

            <BlazeButton
              buttonProps={{
                className: 'mr-2 mb-2',
                type: 'default',
                onClick: toggleBarcodeListener,
                onKeyDown: (e) => e.keyCode === 13 && e.preventDefault(),
              }}
              iconProps={{
                icon: isBarcodeListening ? 'loading' : 'barcode',
              }}
              titleProps={{ title: isBarcodeListening ? 'Scanning...' : 'Start scanning' }}
            />
          </div>
        )}
      </div>
    )
  }
}
